import type { Contact } from '@indutrust/shared-model';
import { createCrudEvents } from '@indutrust/shared-util';

/**
 * Events for CRUD operations on Contact entities.
 *
 * Manages the complete lifecycle of contact data operations:
 * - loadAll, loadById, add, edit, delete
 * Each operation has request, success, and failure variants.
 *
 * Uses 'shared.contact' as the event source namespace for Redux DevTools debugging.
 *
 * @example
 * const dispatch = injectDispatch(contactCrudEvents);
 * dispatch.loadAllRequested({ params: {} });
 */
export const contactCrudEvents = createCrudEvents<Contact>('contact');
